import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, Input, InputGroup, InputGroupText, Label, Row, Spinner } from 'reactstrap';
import { ProductContext } from '../../../store';
import { toast } from 'react-toastify';
import { PostData } from '../../../services/FetchData';
import CBToolTip from '../../../components/CBToolTip';
import DetailSkeleton from '../../../components/Skeleton/DetailSkeleton';
import Cookies from "js-cookie";

const Settings = (props) => {
	const [userDataLocal, setUserDataLocal] = useState({}),
		[errors, setErrors] = useState({}),
		[oldPassword, setOldPassword] = useState(""),
		[newPassword, setNewPassword] = useState(""),
		[oldPasswordShown, setOldPasswordShown] = useState(false),
		[newPasswordShown, setNewPasswordShown] = useState(false),
		[saveApiLoader, setSaveApiLoader]	= useState(false),
		{
			userData,
			setUserData,
			productTypes
		} = useContext(ProductContext)
	const [copyText, setCopyText] = useState("Copy to clipboard"),
		[configLoader, setConfigLoader]	= useState(true),
		[typeSenseConfig, setTypeSenseConfig]	= useState({}),
		[cmsAssistantConfig, setCmsAssistantConfig] = useState({}),
		[cmsConfigLoader, setCmsConfigLoader] = useState(true),
		[totpSetupData, setTotpSetupData] = useState(null),
		[totpEnableCode, setTotpEnableCode] = useState(""),
		[totpDisablePassword, setTotpDisablePassword] = useState(""),
		[totpSetupLoader, setTotpSetupLoader] = useState(false),
		[totpEnableLoader, setTotpEnableLoader] = useState(false),
		[totpDisableLoader, setTotpDisableLoader] = useState(false),
		{
			currentWebsiteId
		} = useContext(ProductContext);
	useEffect(() => {
		setUserDataLocal({ ...userData })
	}, [userData])

	useEffect(() => {
		if( currentWebsiteId && productTypes && productTypes.length > 0 && productTypes.includes("search") ){
			getTypeSenseConfig()
		}
	}, [currentWebsiteId, productTypes])

	useEffect(() => {
		if( currentWebsiteId && productTypes && productTypes.length > 0 && productTypes.includes("cmsassistant") ){
			getCmsAssistantConfig()
		}
	}, [currentWebsiteId, productTypes])

	const getTypeSenseConfig	= () => {
		setConfigLoader(true)
		PostData("ms1", "api/v1/credential/getWebsiteDetails", {websiteId: currentWebsiteId}).then(result => {
			if( result !== "Invalid" && result !== undefined ){
				if( result.status === "success" ){
					setTypeSenseConfig(result.data.credential)
				}else if( result.status === "failure" ){
					toast.error(result.message)
				}else{
					toast.error(result.message.message)
				}
			}
			setConfigLoader(false)
		})
	}

	const getCmsAssistantConfig = () => {
		setCmsConfigLoader(true)
		const token = Cookies.get("_cb_search_token");
		PostData("ms4", "api/v1/cmsAssistant/getWidgetApiKey", {websiteId: currentWebsiteId, token: token}).then(result => {
			if( result !== "Invalid" && result !== undefined ){
				if( result.status === "success" ){
					setCmsAssistantConfig({
						widgetApiKey: result.data.widgetApiKey,
						websiteId: result.data.websiteId
					})
				}else if( result.status === "failure" ){
					console.error(result.message)
				}
			}
			setCmsConfigLoader(false)
		}).catch(error => {
			console.error("Error fetching CMS Assistant config:", error)
			setCmsConfigLoader(false)
		})
	}

	const totpEnabled = !!userData?.totpEnabled;

	const startTotpSetup = () => {
		setTotpSetupLoader(true);
		setTotpSetupData(null);
		PostData("ms1", "api/v1/user/totp/setup", {}).then((result) => {
			if (result && result.status === "success" && result.data) {
				setTotpSetupData({ qrDataUrl: result.data.qrDataUrl, secret: result.data.secret });
			} else {
				toast.error(result?.message || "Failed to start setup");
			}
		}).catch(() => toast.error("Failed to start setup")).finally(() => setTotpSetupLoader(false));
	};

	const confirmTotpEnable = () => {
		const code = totpEnableCode.replace(/\D/g, "").slice(0, 6);
		if (code.length !== 6) {
			toast.error("Enter a 6-digit code");
			return;
		}
		setTotpEnableLoader(true);
		PostData("ms1", "api/v1/user/totp/enable", { code }).then((result) => {
			if (result && result.status === "success") {
				toast.success("Two-factor authentication enabled");
				setTotpSetupData(null);
				setTotpEnableCode("");
				setUserData({ ...userData, totpEnabled: true });
			} else {
				toast.error(result?.message || "Invalid code");
			}
		}).catch(() => toast.error("Failed to enable")).finally(() => setTotpEnableLoader(false));
	};

	const confirmTotpDisable = () => {
		if (!totpDisablePassword) {
			toast.error("Enter your password");
			return;
		}
		setTotpDisableLoader(true);
		PostData("ms1", "api/v1/user/totp/disable", { password: totpDisablePassword }).then((result) => {
			if (result && result.status === "success") {
				toast.success("Two-factor authentication disabled");
				setTotpDisablePassword("");
				setUserData({ ...userData, totpEnabled: false });
			} else {
				toast.error(result?.message || "Invalid password");
			}
		}).catch(() => toast.error("Failed to disable")).finally(() => setTotpDisableLoader(false));
	};

	const handleCopy = (text) => {
		navigator.clipboard.writeText(text).then(() => {
			setCopyText("Copied");
			setTimeout(() => setCopyText("Copy to clipboard"), 2000); // Reset the copied state after 2 seconds
		}).catch(err => {
			console.error('Failed to copy text: ', err);
		});
	}

	const handleChange = (value, index) => {
		setUserDataLocal({
			...userDataLocal,
			[index]: value
		})
		if (index === "firstName") {
			if (value === "") {
				setErrors({
					...errors,
					firstName: "Please enter the first name"
				})
			} else {
				setErrors({
					...errors,
					firstName: null
				})
			}
		} else if (index === "lastName") {
			if (value === "") {
				setErrors({
					...errors,
					lastName: "Please enter the last name"
				})
			} else {
				setErrors({
					...errors,
					lastName: null
				})
			}
		}
	}

	const handlePassword = (value, index) => {
		if (index === "old_password") {
			setOldPassword(value)
			if (newPassword !== "" && value === "") {
				setErrors({
					...errors,
					old_password: "Password field is required"
				})
			} else if (value !== "" && value.length < 8) {
				setErrors({
					...errors,
					old_password: "Password is Too short min 8 char"
				})
			} else {
				let updateObject = {
					...errors,
					old_password: null
				}
				if (newPassword === "") {
					updateObject.new_password = null
				}
				setErrors(updateObject)
			}
		}

		if (index === "new_password") {
			setNewPassword(value)
			if (oldPassword !== "" && value === "") {
				setErrors({
					...errors,
					new_password: "Password field is required"
				})
			} else if (value !== "" && value.length < 8) {
				setErrors({
					...errors,
					new_password: "Password is Too short min 8 char"
				})
			} else {
				let updateObject = {
					...errors,
					new_password: null
				}
				if (oldPassword === "") {
					updateObject.old_password = null
				}
				setErrors(updateObject)
			}
		}
	}

	const saveChanges = () => {
		setSaveApiLoader(true)
		let errorFlag	= false
		if( userDataLocal.firstName === "" ){
			errorFlag	= true
			setErrors({
				...errors,
				firstName: "First name is required"
			})
		}else{
			setErrors({
				...errors,
				firstName: null
			})
		}
		if( userDataLocal.lastName === "" ){
			errorFlag	= true
			setErrors({
				...errors,
				firstName: "Last name is required"
			})
		}else{
			setErrors({
				...errors,
				firstName: null
			})
		}

		if( oldPassword || newPassword ){
			if( oldPassword === "" ){
				errorFlag	= true
				setErrors({
					...errors,
					old_password: "Password filed is required"
				})
			}else if( oldPassword.length < 8 ){
				errorFlag	= true
				setErrors({
					...errors,
					old_password: "Password is Too short min 8 char"
				})
			}else{
				setErrors({
					...errors,
					old_password:null
				})
			}

			if( newPassword === "" ){
				errorFlag	= true
				setErrors({
					...errors,
					new_password: "Password filed is required"
				})
			}else if( newPassword.length < 8 ){
				errorFlag	= true
				setErrors({
					...errors,
					new_password: "Password is Too short min 8 char"
				})
			}else{
				setErrors({
					...errors,
					new_password:null
				})
			}
		}

		if( errorFlag ){
			setSaveApiLoader(false)
			return
		}else{
			PostData("ms1", "api/v1/user/updateProfile", {...userDataLocal, newPassword: newPassword, oldPassword: oldPassword}).then(result => {
				if( result !== "Invalid" && result !== undefined ){
					if( result.status === "success" ){
						setNewPassword("")
						setOldPassword("")
						setUserData({
							...userData,
							firstName: userDataLocal.firstName,
							lastName: userDataLocal.lastName,
						})
						toast.info(result.message)
					}else if( result.status === "failure" ){
						toast.warn(result.message)
					}else if( result.status === "api_error" ){
						toast.warn(result.message.message)
					}
				}
				setSaveApiLoader(false)
			})
		}
	}

	return (
		<>
			<div className='settingPageWrapper'>
				<div className='d-flex justify-content-between'>
					<div className='d-flex align-items-start flex-column w-100'>
						<h1 className='pageMainHeading'>Details</h1>
					</div>
				</div>
				<div className='mt-4'>
					<div className='cardDisplay cardDisplayBody'>
						<div className='d-flex' id="userDetails">
							<div className='w-25 pr4'>
								<h2 className='displayHeadingInformation mb-1'>Person Information</h2>
							</div>
							<div className='w-75'>
								<div className='formFieldWrapper gap35 d-flex flex-column mt-3'>
									<Row>
										<Col xs={12} md={6}>
											<div className={`position-relative ${(errors.firstName && "error_field")}`}>
												<Label className="input-group-alternative-label" >First Name</Label>
												<InputGroup className="input-group-alternative">
													<Input
														placeholder="First Name"
														type="text"
														name="firstName"
														value={userDataLocal.firstName}
														onChange={(e) => handleChange(e.target.value, "firstName")}
														onBlur={(e) => handleChange(e.target.value, "firstName")}
														className={(errors.firstName)}
													/>
												</InputGroup>
												{errors.firstName && (
													<>
														<i className='fa-solid fa-circle-xmark errorIcon'></i>
														<div className="input-feedback">{errors.firstName}</div>
													</>
												)}
											</div>
										</Col>
										<Col xs={12} md={6}>
											<div className={`position-relative ${(errors.lastName && "error_field")}`}>
												<Label className="input-group-alternative-label" >Last Name</Label>
												<InputGroup className="input-group-alternative">
													<Input
														placeholder="Last Name"
														type="text"
														name="lastName"
														value={userDataLocal.lastName}
														onChange={(e) => handleChange(e.target.value, "lastName")}
														onBlur={(e) => handleChange(e.target.value, "lastName")}
														className={(errors.lastName)}
													/>
												</InputGroup>
												{errors.lastName && (
													<>
														<i className='fa-solid fa-circle-xmark errorIcon'></i>
														<div className="input-feedback">{errors.lastName}</div>
													</>
												)}
											</div>
										</Col>
									</Row>
									<Row>
										<Col xs={12}>
											<div className={`position-relative`}>
												<Label className="input-group-alternative-label" >Email</Label>
												<InputGroup className="input-group-alternative">
													<Input
														placeholder="Email"
														type="text"
														name="email"
														disabled
														value={userDataLocal.email}
														className='disabled'
													/>
												</InputGroup>
											</div>
										</Col>
									</Row>
								</div>
							</div>
						</div>
						<hr className="cpBorderTop cbBorderGrey my-4"></hr>
						<div className='d-flex' id="userDetails">
							<div className='w-25 pr4'>
								<h2 className='displayHeadingInformation mb-1'>Update Password</h2>
							</div>
							<div className='w-75'>
								<div className='formFieldWrapper gap35 d-flex flex-column mt-3'>
									<Row>
										<Col xs={12} md={6}>
											<div className={`position-relative passwordField ${(errors.old_password && "error_field")}`}>
												<Label className="input-group-alternative-label" >Your current password</Label>
												<InputGroup className="input-group-alternative">
													<Input
														placeholder="Old Password"
														type={oldPasswordShown ? "text" : "password"}
														name="old_password"
														value={oldPassword}
														onChange={(e) => handlePassword(e.target.value, "old_password")}
														onBlur={(e) => handlePassword(e.target.value, "old_password")}
														className={(errors.old_password)}
														autoComplete={false}
													/>
													<InputGroupText>
														<div className="showPasswordWrapper" onClick={() => setOldPasswordShown(!oldPasswordShown)}>
															{oldPasswordShown ?
																<span className="material-icons-outlined">visibility</span>
																:
																<span className="material-icons-outlined">visibility_off</span>
															}

														</div>
													</InputGroupText>
												</InputGroup>
												{errors.old_password && (
													<>
														<i className='fa-solid fa-circle-xmark errorIcon'></i>
														<div className="input-feedback">{errors.old_password}</div>
													</>
												)}
											</div>
										</Col>
										<Col xs={12} md={6}>
											<div className={`position-relative passwordField ${(errors.new_password && "error_field")}`}>
												<Label className="input-group-alternative-label" >Your new password</Label>
												<InputGroup className="input-group-alternative">
													<Input
														placeholder="New Password"
														type={newPasswordShown ? "text" : "password"}
														name="new_password"
														value={newPassword}
														onChange={(e) => handlePassword(e.target.value, "new_password")}
														onBlur={(e) => handlePassword(e.target.value, "new_password")}
														className={(errors.new_password)}
														autoComplete={false}
													/>
													<InputGroupText>
														<div className="showPasswordWrapper" onClick={() => setNewPasswordShown(!newPasswordShown)}>
															{newPasswordShown ?
																<span className="material-icons-outlined">visibility</span>
																:
																<span className="material-icons-outlined">visibility_off</span>
															}

														</div>
													</InputGroupText>
												</InputGroup>
												{errors.new_password && (
													<>
														<i className='fa-solid fa-circle-xmark errorIcon'></i>
														<div className="input-feedback">{errors.new_password}</div>
													</>
												)}
											</div>
										</Col>
									</Row>
								</div>
							</div>
						</div>
						<hr className="cpBorderTop cbBorderGrey my-4"></hr>
						<div className='d-flex' id="twoFactorAuth">
							<div className='w-25 pr4'>
								<h2 className='displayHeadingInformation mb-1'>Two-factor authentication</h2>
								<p className="cbSubduedText small">Add an extra layer of security with an authenticator app.</p>
							</div>
							<div className='w-75'>
								{!totpEnabled ? (
									<>
										{!totpSetupData ? (
											<Button color="primary" onClick={startTotpSetup} disabled={totpSetupLoader}>
												{totpSetupLoader ? <Spinner size="sm" /> : "Enable two-factor authentication"}
											</Button>
										) : (
											<div className="formFieldWrapper d-flex flex-column mt-3">
												<p className="small">Scan the QR code with your authenticator app (Google Authenticator, Authy, etc.), then enter the 6-digit code below.</p>
												{totpSetupData.qrDataUrl && (
													<div className="mb-3">
														<img src={totpSetupData.qrDataUrl} alt="QR code" style={{ maxWidth: 200, height: "auto" }} />
													</div>
												)}
												{totpSetupData.secret && (
													<p className="small text-muted mb-2">Or enter this secret manually: <code>{totpSetupData.secret}</code></p>
												)}
												<Label>Verification code</Label>
												<Input
													type="text"
													placeholder="000000"
													value={totpEnableCode}
													onChange={(e) => setTotpEnableCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
													maxLength={6}
													className="mb-2"
													style={{ maxWidth: 120 }}
												/>
												<div className="d-flex gap-2">
													<Button color="primary" onClick={confirmTotpEnable} disabled={totpEnableLoader || totpEnableCode.length !== 6}>
														{totpEnableLoader ? <Spinner size="sm" /> : "Confirm and enable"}
													</Button>
													<Button color="link" onClick={() => { setTotpSetupData(null); setTotpEnableCode(""); }}>Cancel</Button>
												</div>
											</div>
										)}
									</>
								) : (
									<div className="formFieldWrapper d-flex flex-column mt-3">
										<p className="small text-success mb-2">Two-factor authentication is enabled.</p>
										<Label>Enter your password to disable</Label>
										<Input
											type="password"
											placeholder="Your password"
											value={totpDisablePassword}
											onChange={(e) => setTotpDisablePassword(e.target.value)}
											className="mb-2"
											style={{ maxWidth: 280 }}
										/>
										<Button color="danger" onClick={confirmTotpDisable} disabled={totpDisableLoader || !totpDisablePassword}>
											{totpDisableLoader ? <Spinner size="sm" /> : "Disable two-factor authentication"}
										</Button>
									</div>
								)}
							</div>
						</div>
						<hr className="cpBorderTop cbBorderGrey my-4"></hr>
						<div className='d-flex align-items-center justify-content-end'>
							<Button color='primary' className='accountSettingSaveBtn cta autoWidth' data-activity="settings.save_profile" disabled={saveApiLoader} onClick={() => saveChanges()}>
								{saveApiLoader &&
									<Spinner size={"sm"} />
								}
								Save Changes
							</Button>
						</div>
					</div>
				</div>
			</div>
			{productTypes && productTypes.length > 0 && productTypes.includes("search") && (
				<div className='settingPageWrapper'>
					<div className='mt-4'>
						<section id="apiKeyCards" className='cardDisplay cardDisplayBody lgMaxWidh550'>
							<div className='apiKeyCardHeaderWrap'>
								<div className='d-flex gap-2'>
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<circle cx="7.5" cy="15.5" r="5.5"></circle>
										<path d="m21 2-9.6 9.6"></path>
										<path d="m15.5 7.5 3 3L22 7l-3-3"></path>
									</svg>
									<h3 className="cbDisplaySmall fw-semi-bold">Your API Keys</h3>
								</div>
								<p className="cbSubduedText mt-2">Use your unique keys below to begin implementing your ConversionBox search application.</p>
							</div>
							{configLoader ?
								<DetailSkeleton />
							:
								<>
									<div className="py-1 mt-2 copyTextInputWrap">
										<Label for="applicationHostInput" className="fw-bold">HOST</Label>
										<div className="relative maxW450">
											<div className="cbInput cbGroup cbInputMedium cbBorderGrey">
												<input className="mx-3 cbNoSearchInputDecoration" type="text" id="applicationHostInput" ariaInvalid="false" readOnly value={typeSenseConfig.host} />
											</div>
											<Button color='link' className="copyButton" ariaLabel="Copy to clipboard" onClick={() => handleCopy(typeSenseConfig.host)}>
												<CBToolTip item={{ placement: 'top', text: copyText }} id="hostTooltip">
													<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
														<rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
														<path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
													</svg>
												</CBToolTip>
											</Button>
										</div>
									</div>
									<div className="py-1 mt-2 copyTextInputWrap">
										<Label for="applicationPortInput" className="fw-bold">PORT</Label>
										<div className="relative maxW450">
											<div className="cbInput cbGroup cbInputMedium cbBorderGrey">
												<input className="mx-3 cbNoSearchInputDecoration" type="text" id="applicationPortInput" ariaInvalid="false" readOnly value={typeSenseConfig.port} />
											</div>
											<Button color='link' className="copyButton" ariaLabel="Copy to clipboard" onClick={() => handleCopy(typeSenseConfig.port)}>
												<CBToolTip item={{ placement: 'top', text: copyText }} id="hostTooltip">
													<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
														<rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
														<path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
													</svg>
												</CBToolTip>
											</Button>
										</div>
									</div>
									<div className="py-1 mt-2 copyTextInputWrap">
										<Label for="applicationProtocolInput" className="fw-bold">PROTOCOL</Label>
										<div className="relative maxW450">
											<div className="cbInput cbGroup cbInputMedium cbBorderGrey">
												<input className="mx-3 cbNoSearchInputDecoration" type="text" id="applicationProtocolInput" ariaInvalid="false" readOnly value={typeSenseConfig.protocol} />
											</div>
											<Button color='link' className="copyButton" ariaLabel="Copy to clipboard" onClick={() => handleCopy(typeSenseConfig.protocol)}>
												<CBToolTip item={{ placement: 'top', text: copyText }} id="hostTooltip">
													<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
														<rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
														<path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
													</svg>
												</CBToolTip>
											</Button>
										</div>
									</div>
									<div className="py-1 mt-2 copyTextInputWrap">
										<Label for="applicationAdminAPIKeyInput" className="fw-bold">ADMIN API KEY</Label>
										<div className="relative maxW450">
											<div className="cbInput cbGroup cbInputMedium cbBorderGrey">
												<input className="mx-3 cbNoSearchInputDecoration" type="text" id="applicationAdminAPIKeyInput" ariaInvalid="false" readonly="" value={typeSenseConfig.adminAPIKey} />
											</div>
											<Button color='link' className="copyButton" ariaLabel="Copy to clipboard" onClick={() => handleCopy(typeSenseConfig.adminAPIKey)}>
												<CBToolTip item={{ placement: 'top', text: copyText }} id="hostTooltip">
													<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
														<rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
														<path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
													</svg>
												</CBToolTip>
											</Button>
										</div>
									</div>
									<div className="py-1 mt-2 copyTextInputWrap">
										<Label for="applicationSearchAPIKeyInput" className="fw-bold">SEARCH API KEY</Label>
										<div className="relative maxW450">
											<div className="cbInput cbGroup cbInputMedium cbBorderGrey">
												<input className="mx-3 cbNoSearchInputDecoration" type="text" id="applicationSearchAPIKeyInput" ariaInvalid="false" readonly="" value={typeSenseConfig.searchAPIKey} />
											</div>
											<Button color='link' className="copyButton" ariaLabel="Copy to clipboard" onClick={() => handleCopy(typeSenseConfig.searchAPIKey)}>
												<CBToolTip item={{ placement: 'top', text: copyText }} id="hostTooltip">
													<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
														<rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
														<path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
													</svg>
												</CBToolTip>
											</Button>
										</div>
									</div>
									<div className="py-1 mt-2 copyTextInputWrap">
										<Label for="applicationSearchAPIKeyInput" className="fw-bold">UNIQUE ID</Label>
										<div className="relative maxW450">
											<div className="cbInput cbGroup cbInputMedium cbBorderGrey">
												<input className="mx-3 cbNoSearchInputDecoration" type="text" id="applicationSearchAPIKeyInput" ariaInvalid="false" readonly="" value={typeSenseConfig.uniqueId} />
											</div>
											<Button color='link' className="copyButton" ariaLabel="Copy to clipboard" onClick={() => handleCopy(typeSenseConfig.uniqueId)}>
												<CBToolTip item={{ placement: 'top', text: copyText }} id="hostTooltip">
													<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
														<rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
														<path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
													</svg>
												</CBToolTip>
											</Button>
										</div>
									</div>
								</>
							}
							{/* <ContentEditable /> */}
						</section>
					</div>
				</div>
			)}
			{productTypes && productTypes.length > 0 && productTypes.includes("cmsassistant") && (
				<div className='settingPageWrapper'>
					<div className='mt-4'>
						<section id="cmsAssistantApiKeyCards" className='cardDisplay cardDisplayBody lgMaxWidh550'>
							<div className='apiKeyCardHeaderWrap'>
								<div className='d-flex gap-2'>
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<circle cx="7.5" cy="15.5" r="5.5"></circle>
										<path d="m21 2-9.6 9.6"></path>
										<path d="m15.5 7.5 3 3L22 7l-3-3"></path>
									</svg>
									<h3 className="cbDisplaySmall fw-semi-bold">CMS Assistant Integration</h3>
								</div>
								<p className="cbSubduedText mt-2">Use this API key to connect your CMS with ConversionBox for transferring content.</p>
							</div>
							{cmsConfigLoader ?
								<DetailSkeleton />
							:
								<>
									<div className="py-1 mt-2 copyTextInputWrap">
										<Label for="cmsApiKeyInput" className="fw-bold">API KEY</Label>
										<div className="relative maxW450">
											<div className="cbInput cbGroup cbInputMedium cbBorderGrey">
												<input className="mx-3 cbNoSearchInputDecoration" type="text" id="cmsApiKeyInput" ariaInvalid="false" readOnly value={cmsAssistantConfig.widgetApiKey || ""} />
											</div>
											<Button color='link' className="copyButton" ariaLabel="Copy to clipboard" onClick={() => handleCopy(cmsAssistantConfig.widgetApiKey)}>
												<CBToolTip item={{ placement: 'top', text: copyText }} id="cmsApiKeyTooltip">
													<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
														<rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
														<path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
													</svg>
												</CBToolTip>
											</Button>
										</div>
									</div>
								</>
							}
						</section>
					</div>
				</div>
			)}
		</>
	);
}

export default Settings;